// Renderer de markdown mínimo, portado de real-estate-chatbot/frontend/markdown.js.
// Escapa el HTML antes de aplicar el formato, así que la respuesta del agente
// nunca puede inyectar marcado propio.

function escapeHtml (text) {
  const div = document.createElement('div')
  div.textContent = text == null ? '' : text
  return div.innerHTML
}

function renderInline (text) {
  let html = text
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, label, url) => {
    const safeUrl = escapeHtml(url).replace(/^javascript:/i, '')
    return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${escapeHtml(label)}</a>`
  })
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  // Sin lookbehind: no todos los navegadores del browserslist lo soportan.
  html = html.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>')
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>')
  return html
}

const isHeading = (line) => /^#{1,3}\s+/.test(line)
const isBullet = (line) => /^[-*]\s+/.test(line)
const isOrdered = (line) => /^\d+\.\s+/.test(line)

export function renderMarkdown (text) {
  if (!text) return ''

  const lines = String(text).split('\n')
  const blocks = []
  let i = 0

  while (i < lines.length) {
    const line = lines[i]

    if (isHeading(line)) {
      const level = Math.min(line.match(/^#+/)[0].length + 1, 4)
      const content = renderInline(escapeHtml(line.replace(/^#{1,3}\s+/, '')))
      blocks.push(`<h${level} class="md-heading">${content}</h${level}>`)
      i += 1
      continue
    }

    if (isBullet(line)) {
      const items = []
      while (i < lines.length && isBullet(lines[i])) {
        items.push(`<li>${renderInline(escapeHtml(lines[i].replace(/^[-*]\s+/, '')))}</li>`)
        i += 1
      }
      blocks.push(`<ul class="md-list">${items.join('')}</ul>`)
      continue
    }

    if (isOrdered(line)) {
      const items = []
      while (i < lines.length && isOrdered(lines[i])) {
        items.push(`<li>${renderInline(escapeHtml(lines[i].replace(/^\d+\.\s+/, '')))}</li>`)
        i += 1
      }
      blocks.push(`<ol class="md-list">${items.join('')}</ol>`)
      continue
    }

    if (line.trim() === '') {
      i += 1
      continue
    }

    const paragraph = []
    while (
      i < lines.length &&
      lines[i].trim() !== '' &&
      !isHeading(lines[i]) &&
      !isBullet(lines[i]) &&
      !isOrdered(lines[i])
    ) {
      paragraph.push(lines[i])
      i += 1
    }
    blocks.push(`<p>${renderInline(escapeHtml(paragraph.join('\n')))}</p>`)
  }

  return `<div class="md-content">${blocks.join('')}</div>`
}

export default renderMarkdown
